import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Modal, Field } from '../ui/Modal';
import { Icon } from '../ui/Icon';
import { api, ApiError } from '../../lib/api';
import { toast } from '../../stores/toast.store';

interface Props {
  onClose: () => void;
  clientId: string;
  contact?: { id: string; fullName: string; role: string | null; email: string | null; phone: string | null; isPrimary: boolean };
}

export function NewContactModal({ onClose, clientId, contact }: Props) {
  const qc = useQueryClient();
  const [form, setForm] = useState({
    fullName: contact?.fullName ?? '',
    role: contact?.role ?? '',
    email: contact?.email ?? '',
    phone: contact?.phone ?? '',
    isPrimary: contact?.isPrimary ?? false,
  });

  const save = useMutation({
    mutationFn: () => contact
      ? api.patch(`/clients/contacts/${contact.id}`, form)
      : api.post(`/clients/${clientId}/contacts`, form),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['client', clientId] });
      toast.ok(contact ? 'Referente aggiornato' : 'Referente aggiunto', form.fullName);
      onClose();
    },
    onError: (err) => toast.alert(contact ? 'Errore aggiornamento referente' : 'Errore aggiunta referente', err instanceof ApiError ? err.message : 'Riprova'),
  });

  return (
    <Modal
      title={contact ? 'Modifica referente' : 'Nuovo referente'}
      kicker="CRM · Contatti"
      onClose={onClose}
      size="md"
      footer={
        <>
          <button className="btn btn-ghost" onClick={onClose}>Annulla</button>
          <div className="spacer" />
          <button className="btn btn-primary" onClick={() => save.mutate()} disabled={!form.fullName || save.isPending}>
            {contact ? 'Salva' : 'Aggiungi'} <Icon name="arrowRight" size={12} />
          </button>
        </>
      }
    >
      <div className="form-grid">
        <Field label="Nome e cognome" required span={12}>
          <input className="inp" value={form.fullName} onChange={(e) => setForm({ ...form, fullName: e.target.value })} autoFocus />
        </Field>
        <Field label="Ruolo" span={12}>
          <input className="inp" placeholder="CMO, CFO, Responsabile marketing…" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} />
        </Field>
        <Field label="Email" span={7}>
          <input className="inp" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </Field>
        <Field label="Telefono" span={5}>
          <input className="inp" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
        </Field>
        <Field span={12}>
          <label className="flex items-center gap-2 text-[13px]">
            <input type="checkbox" checked={form.isPrimary} onChange={(e) => setForm({ ...form, isPrimary: e.target.checked })} />
            Referente principale
          </label>
        </Field>
      </div>
    </Modal>
  );
}
